    import { useSpreadSheet } from "./useSpreadSheet";
    import IconDownload from '@zendeskgarden/svg-icons/src/16/download-stroke.svg?react';
    import * as Css from "./style";
    import { SpreadSheetProps } from "./spreadsheetType";
    import { TicketTemplateModal } from "../modal/templateTicketModal";


    export function DownloadSpreadsheet({ type, listing = false }: SpreadSheetProps) {
        const { downloadSpreadsheet, openModal, openCustomModal, forms, selectedForm, setOpenModal, setSelectedForm } = useSpreadSheet({ type })

        return (
            <>
                <Css.ButtonDownload onClick={listing ? undefined : type !== "ticket" ? downloadSpreadsheet : openCustomModal}>
                    <IconDownload />
                    {!listing ?
                        <span>
                            Baixar template de planilha
                        </span>
                        :
                        <span>
                            Baixar listagem
                        </span>
                    }
                </Css.ButtonDownload>

                {
                    openModal && type === "ticket" && (
                        <TicketTemplateModal
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            forms={forms}
                            selectedForm={selectedForm}
                            setSelectedForm={setSelectedForm}
                            onDownload={downloadSpreadsheet}
                        />
                    )
                }
            </>
        );
    }
